import React from 'react';

export default function ChatterPagination({ chatter }) {
  const { page, hasMore, loading, error, load } = chatter;
  return <div className="px-4 py-3 border-t border-gray-200">
    {error && <p role="alert" className="text-sm text-red-700">{error} <button type="button" onClick={() => load(page)}>Réessayer</button></p>}
    <nav aria-label="Pagination des échanges" className="flex items-center justify-between gap-3 text-sm">
      <button type="button" className="px-3 py-2 rounded-lg border disabled:opacity-40" disabled={loading || page === 1} onClick={() => load(page - 1)}>Plus récents</button>
      <span aria-live="polite">Page {page}</span>
      <button type="button" className="px-3 py-2 rounded-lg border disabled:opacity-40" disabled={loading || !hasMore} onClick={() => load(page + 1)}>Plus anciens</button>
    </nav>
  </div>;
}
